import classes from 'components/common/LodaerSpinner/LoaderSpinner.module.scss';

interface Props {
    className?: string;
    color?: string;
}

export const LoaderSpinner = ({ className = '', color }: Props) => {
    const style = color ? { borderTopColor: color } : undefined;
    return <div data-testid={'loader'} className={`${classes.loader} ${className}`} style={style} />;
};
